/**
 * @description: 推荐商品汇总报表
 * @author: hwx
*/
<template>
    <div class="tsr-tjsh-report">
        <div class="tjsh-list">
            <el-form :inline="true" size="small" :model="tjsh_list_form">
                <el-form-item label="时间">
                    <div class="clearfix" ref="tjsh_list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="tjsh_list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="tjsh_list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="tjsh_list_form.shop_id" filterable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="推荐商品名称">
                    <el-input placeholder="请输入推荐商品名称" v-model="tjsh_list_form.name"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getTjshList(1)">查询</el-button>
                    <el-button @click="tjshExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="tsr-row">
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="tjsh_list">
                <el-table-column prop="relation_name" label="推荐套餐名称"></el-table-column>
                <el-table-column prop="discount_price" label="价格"></el-table-column>
                <el-table-column prop="quantity" label="数量"></el-table-column>
                <el-table-column prop="total_discount_price" label="实收总额"></el-table-column>
                <el-table-column prop="ticket_price" label="门票收入"></el-table-column>
                <el-table-column prop="a_price" label="A类酒水收入"></el-table-column>
                <el-table-column prop="b_price" label="B类酒水收入"></el-table-column>
                <el-table-column prop="c_price" label="C类酒水收入"></el-table-column>
                <el-table-column prop="d_price" label="D类酒水收入"></el-table-column>
                <el-table-column prop="time_price" label="房费收入"></el-table-column>
            </el-table>
            <div class="pagination-row">
                <div>
                    <label class="list-label-3">总数量:</label>
                    <div class="list-total">{{tjsh_quantity}}</div>
                    <label class="list-label-4">实收总额:</label>
                    <div class="list-total">{{tjsh_discount_price}}</div>
                </div>
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :page-size="GLOBAL.PAGESIZE"
                    :current-page.sync="tjsh_list_page"
                    :total="tjsh_list_total"
                    @current-change="getTjshList">
                </el-pagination>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="tjsh_list_export">
                <h2>请选择导出报表需要的显示的字段</h2>
                <el-checkbox :indeterminate="tjsh_export_sign" v-model="tjsh_export_all" @change="tjshExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="tjsh_export_ids" @change="tjshExportChange">
                    <el-checkbox label="relation_name">推荐套餐名称</el-checkbox>
                    <el-checkbox label="discount_price">价格</el-checkbox>
                    <el-checkbox label="quantity">数量</el-checkbox>
                    <el-checkbox label="total_discount_price">实收总额</el-checkbox>
                    <el-checkbox label="ticket_price">门票收入</el-checkbox>
                    <el-checkbox label="a_price">A类酒水收入</el-checkbox>
                    <el-checkbox label="b_price">B类酒水收入</el-checkbox>
                    <el-checkbox label="c_price">C类酒水收入</el-checkbox>
                    <el-checkbox label="d_price">D类酒水收入</el-checkbox>
                    <el-checkbox label="time_price">房费收入</el-checkbox>
                </el-checkbox-group>
                <h2>请选择导出报表的文件格式</h2>
                <el-radio v-model="tjsh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="tjsh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                tjsh_list_form: {
                    start_time: moment().subtract(1, 'day').format('YYYY-MM-DD 08:00'),
                    end_time: moment().format('YYYY-MM-DD 08:00'),
                    shop_id: '',
                    name: ''
				},
                tjsh_quantity: '',
                tjsh_discount_price: '',
				tjsh_list: [],
				tjsh_list_page: 1,
                tjsh_list_total: 0,
                tjsh_export_sign: false,
				tjsh_export_all: false,
                tjsh_export_ids: [],
                tjsh_export_list: ['relation_name', 'discount_price', 'quantity', 'total_discount_price', 'ticket_price', 'a_price', 'b_price', 'c_price', 'd_price', 'time_price'],
                tjsh_export_type: '1',
            }
        },
        mounted: function() {
            this.initDate()
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.tjsh_list_form.shop_id = this.shop_list[0].id
                this.getTjshList(1)
            })
        },
        methods: {
            // 初始化日期插件
            initDate: function() {
                const _this = this
                $(_this.$refs.tjsh_list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().subtract(1, 'day').toDate(),
                    endDate: moment().toDate(),
                    maxDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.tjsh_list_form.start_time = start.format('YYYY-MM-DD 08:00')
                    _this.tjsh_list_form.end_time = end.format('YYYY-MM-DD 08:00')
                })
            },
            // 门店
            getShop: function(resolve) {
                const _this = this

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result
                        _this.shop_list.shift()
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this)
                        layer.msg(res.data.response.error_msg)
                    }
                })
                .catch(err => {
                    layer.msg('出错啦')
                })
            },



            getTjshList(page) {
				const _this = this;

				_this.loading = true
                _this.tjsh_list_page = page
				Vue.axios.post('TicketOrder/getTicketGiftCountList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.tjsh_list_form.start_time,
                            "end_time": _this.tjsh_list_form.end_time,
							"shop_id": _this.tjsh_list_form.shop_id,
							"name": _this.tjsh_list_form.name
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.tjsh_list_total = Number(res.data.response.result.total_data.total)
							_this.tjsh_quantity = res.data.response.result.total_data.quantity
							_this.tjsh_discount_price = res.data.response.result.total_data.discount_price
						}
						_this.tjsh_list = res.data.response.result.rows
						_this.loading = false
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
            },
            // 导出
            tjshExportAll(val) {
				this.tjsh_export_ids = val ? this.tjsh_export_list : [];
				this.tjsh_export_sign = false;
			},
			tjshExportChange(val) {
				const len = val.length;
				this.tjsh_export_all = len === this.tjsh_export_list.length;
				this.tjsh_export_sign = len > 0 && len < this.tjsh_export_list.length;
			},
            tjshExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "TicketOrder/exportGiftCountList"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.tjsh_export_ids = res.data.response.result.export_fields;
                            _this.tjsh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.tjsh_export_ids = _this.tjsh_export_list;
                            _this.tjsh_export_type = '1';
                        }
                        _this.tjshExportChange(_this.tjsh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.tjsh_list_export)
                }, function() {
                    _this.tjshExport();
                });
            },
            tjshExport: function() {
                window.location.href = Vue.ctUrl + "TicketOrder/exportGiftCountList" +
                    "?start_time=" + this.tjsh_list_form.start_time +
                    "&end_time=" + this.tjsh_list_form.end_time +
                    "&shop_id=" + this.tjsh_list_form.shop_id +
                    "&name=" + this.tjsh_list_form.name +
                    "&export_fields=" + JSON.stringify(this.tjsh_export_ids) +
                    "&export_type=" + this.tjsh_export_type
                layer.closeAll()
                layer.msg("导出成功！")
            },
        }
    }
</script>
<style lang="less" scoped>
    .export-wrap {
        h2 {
            margin: 20px 0 15px 0;
            font-size: 16px;
        }
    }
</style>